import ConfirmAction from '@/components/modals/confirm-action';
import ManageWarehouseForm from '@/PageComponents/Warehouse/ManageWarehouseForm';
import featureService from '@/services/feature/feature-service';
import storeService from '@/services/store/store-service';
import warehouseService from '@/services/warehouse/warehouse-service';
import constants from '@/utils/constants';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import helper from '@/utils/helper';
import { Card, Container } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { FC, useEffect, useRef, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router'



const VanCreatePage: FC = () => {

    const [subscriptionInfo] = useState(() => Storage.getCookie(Enums.Cookie.subscriptionInfo));

    const defaultStore = useRef<any>(null)
    const [defaultStoreRetrieved, setDefaultStoreRetrieved] = useState(false);

    const getDefaultStore = async () => {

        const defaultStoreResult = (subscriptionInfo as any)?.MultiStore === true ? null : await storeService.getDefaultStore();
        defaultStore.current = defaultStoreResult;
        setDefaultStoreRetrieved(true);
    }

    useEffect(() => {
        getDefaultStore();
    }, []);

    const router = useRouter();

    const [confirmOptions, setConfirmOptions] = useState(helper.initialiseConfirmOptions());
    const { data: hasStockTake } = useQuery(['hasStockTake'], () => featureService.getFeature(constants.features.STOCK_TAKE));

    if (!defaultStoreRetrieved) return <></>;

    return (<>
        <Container size={"xl"} p="md">
            <Card shadow="sm" padding="lg" radius="md" withBorder flex={2} pos={'relative'}>
                <ManageWarehouseForm
                    isNew={true}
                    caller='pages/van/create'
                    onBack={(id: any) => {
                        if (!id) {
                            helper.nextRouter(router.push, '/inventory/list?tab=vanstock', '/inventory/list?tab=vanstock');
                        }
                        else {
                            if (hasStockTake) {
                                setConfirmOptions({
                                    ...helper.initialiseConfirmOptions(),
                                    heading: 'Van Created',
                                    text: "Van created successfully. Do you want to perform a stock take?",
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    onCancel: () => helper.nextRouter(router.push, '/van/[id]', `/van/${id}`),
                                    onConfirm: () => helper.nextRouter(router.push, `/stock-take/create?wid=${id}`, `/stock-take/create?wid=${id}`),
                                    display: true
                                })
                            }
                            else {
                                helper.nextRouter(router.push, '/van/[id]', `/van/${id}`)
                            }

                        }
                    }}
                    onCancel={() => {
                        helper.nextRouter(router.push, '/inventory/list?tab=vanstock', '/inventory/list?tab=vanstock');
                    }}
                    defaultStore={defaultStore.current}
                />
            </Card>
        </Container>

        <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

        <style jsx>{`
            
        `}</style>
    </>);
};

export default VanCreatePage;

export const Route = createFileRoute('/_authenticated/van/create')({ component: VanCreatePage })
